'use client';

import { motion } from 'framer-motion';
import { ReactNode } from 'react';

import { tw } from '../../utils';

interface TileWrapperProps {
  size?: 'small' | 'default' | 'medium' | 'large';
  handleClick?: () => void;
  selectedBackgroundClass: string | null;
  isDisabled: boolean;
  isSelected: boolean;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const defaultTransition = {
  type: 'spring',
  stiffness: 400,
  damping: 10,
};

export const TileWrapper: React.FC<TileWrapperProps> = ({
  handleClick,
  selectedBackgroundClass,
  isDisabled,
  isSelected,
  className,
  footer,
  children,
}: TileWrapperProps) => {
  const isPublic = false;

  const hoverEffect =
    (!isPublic && !isDisabled) || !isDisabled ? { scale: 1.05 } : { scale: 1 };
  const tapEffect =
    (!isPublic && !isDisabled) || !isDisabled ? { scale: 0.95 } : { scale: 1 };
  const transitionEffect =
    (!isPublic && !isDisabled) || !isDisabled ? defaultTransition : {};

  const bgIsWhite = selectedBackgroundClass === 'bg-white';

  return (
    <motion.button
      onClick={!isDisabled ? handleClick : undefined}
      whileHover={hoverEffect}
      whileTap={tapEffect}
      transition={transitionEffect}
      className={tw(
        isSelected ? `${selectedBackgroundClass} p-1.5` : 'bg-transparent',
        'relative',
        !!footer && !isSelected ? 'rounded-t-[20px]' : 'rounded-[20px]',
        isPublic && 'hover:cursor-default',
        className,
      )}
      disabled={isDisabled}
    >
      <div
        className={tw(
          'relative flex flex-col',
          isDisabled ? 'hover:cursor-not-allowed' : null,
          bgIsWhite
            ? isSelected
              ? 'rounded-[17px] bg-black/[.20]'
              : 'rounded-[20px] bg-white/[.22]'
            : isSelected
              ? 'rounded-[17px] bg-white/[.46]'
              : 'rounded-[20px] bg-white/[.22]',
        )}
        style={{
          boxShadow:
            '4px 4px 26px 0px rgba(255, 255, 255, 0.05) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
          backdropFilter: 'blur(9px)',
        }}
      >
        <div
          className={tw(
            'relative flex aspect-square items-center justify-center',
          )}
        >
          {children}
        </div>
        {!!footer && <div className='w-full p-1.5'>{footer}</div>}
      </div>
    </motion.button>
  );
};
